<template>
  <card title="Public doctor page">
    <p v-if="view.url"><a :href="view.url" target="_blank" rel="noopener noreferrer">{{ view.url }}</a></p>
    <p class="text-muted">Saved address, not a URL generated from the edited name.</p>
    <p v-if="view.loading">Checking URL ownership and clinic visibility…</p>
    <p v-for="warning in view.warnings" :key="warning" class="text-warning" role="alert">{{ warning }}</p>
    <ul v-if="view.conflicts.length">
      <li v-for="owner in view.conflicts" :key="owner.id">
        <a :href="`/admin/doctor/${owner.id}`" target="_blank" rel="noopener noreferrer">
          #{{ owner.id }} — {{ owner.name || 'Doctor' }} (clinic {{ owner.clinic_id || 'unknown' }})
        </a>
      </li>
    </ul>
    <p v-if="view.checked" class="text-muted">No current alias conflict found. This is not an HTTP availability check.</p>
    <button type="button" class="btn btn-sm btn-primary" @click="refresh">Refresh checks</button>
  </card>
</template>

<script>
import APIClinics from '@/api/modules/clinics';
import APIDoctors from '@/api/modules/doctors';
import { createDoctorPageLoader, doctorPageKey, reconcileDoctorPage } from './doctorPublicPageState';

export default {
  props: { doctor: { type: Object, required: true } },
  data: () => ({ evidence: null, pageLoader: null }),
  computed: {
    requestKey() { return doctorPageKey(this.doctor); },
    view() { return reconcileDoctorPage(this.doctor, this.evidence); },
  },
  watch: {
    requestKey() { this.refresh(); },
  },
  created() {
    this.pageLoader = createDoctorPageLoader(
      id => APIClinics.getClinic(id, { timeout: 10000 }).then(response => response.data && response.data.clinic),
      alias => APIDoctors.getCurrentAliasOwners(alias).then(response => response.data),
    );
    this.refresh();
  },
  beforeDestroy() { this.pageLoader.invalidate(); },
  methods: {
    refresh() { return this.pageLoader.load(this.doctor, evidence => { this.evidence = evidence; }); },
  },
};
</script>
